import { RefObject } from 'react';

export const handleVideoFocus = (
  videoRefs: RefObject<any[]>,
  activeIndex: number | undefined,
  prevIndex: number,
): void => {
  if (videoRefs.current) {
    if (activeIndex !== undefined) {
      videoRefs.current[activeIndex]?.play();
    }
    if (prevIndex !== -1 && videoRefs.current[prevIndex]) {
      videoRefs.current[prevIndex]?.pause();
      videoRefs.current[prevIndex].currentTime = 0;
    }
  }
};
